<a
  [routerLink]="[menuDefault().url]"
  (click)="handleClick()"
>
  <div
    class="menu-item-wrapper"
    [class]="{
      'active': isMenuActive(),
      'collapsed-menu': isMenuSmall()
    }"
  >
    <i
      class="menu-item-icon"
      [class]="menuDefault().iconName"
    ></i>
    @if (!isMenuSmall() && isMenuAvailableToCurrentUser()) {
      <div
        class="menu-item-name menu-item-name-link"
        @smoothShowHideWidth
        translate="no"
      >
        {{ menuDefault().tag }}
      </div>
    }
  </div>
</a>

